import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import { makeStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";
// import styles from "assets/jss/material-dashboard-pro-react/components/headingStyle.js";

const useStyles = makeStyles({
  title: {
    fontWeight: "700 !important",
    fontSize: "18px !important",
    marginLeft: "15px",
  },
  heading: {
    display: "flex",
    padding: "5px 0px",
  },
});
export default function Heading(props) {
  const { textAlign, category, title } = props;
  const classes = useStyles();
  // const heading =
  //   classes.heading +
  //   " " +
  //   cx({
  //     [classes[textAlign + "TextAlign"]]: textAlign !== undefined
  //   });
  if (title !== undefined || category !== undefined) {
    return (
      <div className={classes.heading}>
        <span style={{ borderLeft: "3px solid #0095DA" }}></span>

        {title !== undefined ? (
          <Typography className={classes.title} variant="h6" style={{color:'black'}}>
            {title}
            <span style={{fontSize:"13px"}}>{props.children}</span>
          </Typography>
        ) : null}
        {category !== undefined ? (
          <p className={classes.category}>{category}</p>
        ) : null}
      </div>
    );
  }
  return null;
}

Heading.propTypes = {
  title: PropTypes.node,
  category: PropTypes.node,
  textAlign: PropTypes.oneOf(["right", "left", "center"]),
};
